import { useState } from 'react';

import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

const DataTableSearchCreateHeader = (props: {
  onCreate?: () => void;
  onSearchChange: (value: string) => void;
  searchDisabled?: boolean;
  createNewDisabled?: boolean;
}): JSX.Element => {
  const { onCreate, onSearchChange, searchDisabled = false, createNewDisabled = false } = props;

  const [search, setSearch] = useState<string>('');

  return (
    <div className="flex flex-col lg:flex-row justify-between gap-3 p-input-filled">
      {!searchDisabled ? (
        <span className="p-input-icon-left">
          <i className="pi pi-search text-gray-400" />
          <InputText
            className="min-w-[280px] !rounded-lg !border-gray-200 !text-[0.85rem]"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              onSearchChange(e.target.value);
            }}
            placeholder="Search..."
          />
        </span>
      ) : (
        <div></div>
      )}
      {!createNewDisabled && !!onCreate && (
        <div>
          <Button icon="pi pi-plus" label="Add New" className="p-button-sm !rounded-lg" onClick={onCreate} />
        </div>
      )}
    </div>
  );
};

export default DataTableSearchCreateHeader;
